import React from 'react';
import { useMaintenance } from '../contexts/MaintenanceContext';
import { useTheme } from '../contexts/ThemeContext';
import { useContent } from '../hooks/useContent';

const Maintenance = () => {
  const { maintenanceMessage } = useMaintenance();
  const { isDark } = useTheme();
  const { content, loading: contentLoading } = useContent('maintenance');

  if (contentLoading || !content) {

    return (
      <div className={`pt-16 min-h-screen flex items-center justify-center ${isDark ? 'bg-dark-900' : 'bg-gray-50'}`}>
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    );
  }
  return (
    <div className={`min-h-screen flex items-center justify-center px-4 ${isDark ? 'bg-gray-900' : 'bg-gray-50'}`}>
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <svg
            className={`mx-auto h-24 w-24 ${isDark ? 'text-yellow-400' : 'text-yellow-500'}`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008z"
            />
          </svg>
        </div>

        <h1 className={`text-3xl font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
	  {content.mainHeader}
        </h1>

        <p className={`text-lg mb-8 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
          {maintenanceMessage || content.defaultMessage}
        </p>
        <p className={`mt-8 text-sm ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
	  {content.sorryMessage}
        </p>
      </div>
    </div>
  );
};

export default Maintenance;
